export default "__VITE_ASSET__DMgHIHak__"